import React from 'react';
import WaitCube from './WaitCube';
import {_GPY} from './env.js'

class Wait extends React.Component {

  render () {
		return (
			<div className="container-fluid" style={this.props.width!==undefined&&this.props.height!==undefined?{width: this.props.width+"px", height: this.props.height+"px", backgroundColor: "rgba(0, 0, 0, 0)"}:{}}>
			   <div className="row justify-content-center">
			       <div className="col-10 text-center">
                <WaitCube/>
                <img style={{maxWidth : '200px'}} src={_GPY.resource("images/guppyi_logo.png")} className="img-fluid mx-auto pb-100" alt="Guppyi Logo"/>
			       </div>
			   </div>
         <div className="row justify-content-center">
			       <div className="col-10 text-center">
                <span className="text-info">{this.props.message}</span>
			       </div>
			   </div>
			</div>
		)
  }
}
export default Wait;
